import { slideMenu, accordionPanel } from './modules/slideMenu';
import { pageTop, anchorLink } from './modules/smoothscroll';
import { classAdd } from './modules/classAdd';
import { initGlightbox } from './modules/glightbox';

jQuery(function ($) {
  slideMenu($);
  accordionPanel($);
  pageTop($);
  classAdd($);
});

// jQuery不要な処理は外で実行
anchorLink();

document.addEventListener('DOMContentLoaded', () => {
  initGlightbox();
});
